<template>
    <v-dialog v-model="activate" persistent width="400" class="d-flex payment-modal">

        <v-card>

            <v-app-bar color="primary" dense dark>

                <v-toolbar-title>{{$t('plans')}}</v-toolbar-title>

            </v-app-bar>

            <v-container>

                <v-row>
                    <v-col>

                        <card-plan-admin />

                    </v-col>
                </v-row>

            </v-container>

        </v-card>

    </v-dialog>
</template>

<script>
import CardPlanAdmin from './CardPlanAdmin'
export default {
    name: 'ModalToPayment',
    props: ['activate'],
    components: { CardPlanAdmin }

}
</script>

<style>

</style>